import { Modal } from 'antd';
import { injectIntl } from 'react-intl';

import { sendSegment } from 'utils/segment';
import { SUBSCRIPTION_ANNOUNCEMENT_PRICE } from 'constants/subscription';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as RocketIcon } from 'assets/bosta-icons/rocket.svg';
import { ReactComponent as CircleCheck } from 'assets/bosta-icons/Circle-Check.svg';

import './SubscriptionAnnouncementModal.less';

const SubscriptionAnnouncementModal = ({
  intl,
  close,
  onSubscribe,
  ...props
}) => {
  const { formatMessage } = intl;

  const handleSubscribeClick = () => {
    sendSegment('E_SLLR_PAID_ANNOUNCEMENT_SUBSCRIBE_CLICKED');
    close();
    onSubscribe();
  };

  const handleDismiss = () => {
    sendSegment('E_SLLR_PAID_ANNOUNCEMENT_DISMISSED');
    close();
  };

  const featureKeys = [
    'subscription.announcement.features.feature_1',
    'subscription.announcement.features.feature_2',
    'subscription.announcement.features.feature_3'
  ];

  return (
    <Modal
      className="br-subscription-announcement-modal"
      title={null}
      footer={null}
      width={null}
      onCancel={handleDismiss}
      {...props}
    >
      <div className="br-subscription-announcement-modal__banner">
        <div className="br-subscription-announcement-modal__icon">
          <RocketIcon />
        </div>
        <div className="br-subscription-announcement-modal__price-pill">
          {formatMessage(
            { id: 'subscription.announcement.price_pill' },
            { amount: SUBSCRIPTION_ANNOUNCEMENT_PRICE }
          )}
        </div>
      </div>

      <div className="br-subscription-announcement-modal__content">
        <p className="display-sm br-subscription-announcement-modal__title">
          {formatMessage({ id: 'subscription.announcement.title' })}
        </p>
        <p className="body br-subscription-announcement-modal__subtitle">
          {formatMessage(
            { id: 'subscription.announcement.subtitle' },
            { amount: SUBSCRIPTION_ANNOUNCEMENT_PRICE }
          )}
        </p>

        <ul className="br-subscription-announcement-modal__features">
          {featureKeys.map((id) => (
            <li key={id}>
              <CircleCheck />
              <p className="body-medium">{formatMessage({ id })}</p>
            </li>
          ))}
        </ul>

        <div className="br-subscription-announcement-modal__actions">
          <BRButton
            type="primary"
            className="br-subscription-announcement-modal__subscribe-btn"
            label={formatMessage({ id: 'subscription.announcement.cta' })}
            onClick={handleSubscribeClick}
          />
          <BRButton
            type="link-gray"
            className="br-subscription-announcement-modal__dismiss-btn"
            label={formatMessage({ id: 'subscription.announcement.dismiss' })}
            onClick={handleDismiss}
          />
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(SubscriptionAnnouncementModal);
